import UserDataService from '../../service/UserDataService'

const userPermissions = {
    map: [],
    field: [],
    dynacrop: [],
    dashboard: [],
    graphs: [],
    history: [],
    fieldbook: [],
    analytics: [],
}

const newUserProbe = {
    probe_id: null,
    date_from: null,
    date_to: null,
}

const initialState = {
    loading: false,
    users: [],
    usersList: [],
    activeUser: null,
    newUserProbe: { ...newUserProbe },
    tableOptions: null,
    searchString: '',
    usersCount: 0,
    permissions: {},
    userPermissions: { ...userPermissions },
}

export default {
    namespaced: true,
    state: { ...initialState },
    actions: {
        async fetchUserList({ commit, state }) {
            try {
                let params = {
                    search: state.searchString,
                    page: state.tableOptions && state.tableOptions.page ? state.tableOptions.page : null,
                    itemsPerPage:
                        state.tableOptions && state.tableOptions.itemsPerPage ? state.tableOptions.itemsPerPage : null,
                }
                commit('setLoading', true)
                const resp = await UserDataService.getAll(params)

                if (resp.status === 200) {
                    commit('setUsersList', resp.data.users)
                    commit('setUsersCount', resp.data.users_count)
                }

                commit('setLoading', false)
            } catch (e) {
                console.log(e)
                commit('setLoading', false)
            }
        },
        async fetchUser({ commit, dispatch, rootState }, id) {
            try {
                const resp = await UserDataService.get(id)
                if (resp.status === 200) {
                    let userRole = rootState.auth.user.role
                    if (userRole === 'super_admin' || userRole === 'admin' || userRole === 'country_manager') {
                        await dispatch('userPermissions/fetchAllUsersTags', id, { root: true })
                    }
                    await commit('userPermissions/setUserTags', resp.data, { root: true })
                    commit('setActiveUser', resp.data)
                    commit('setUserPermissions', resp.data.user_permissions)
                }
            } catch (e) {
                console.log(e)
            }
        },
        async updateUser({ state, commit, dispatch }) {
            try {
                commit('setLoading', true)
                const resp = await UserDataService.update(state.activeUser)

                if (resp.status === 200) {
                    await dispatch('fetchUser', state.activeUser.id)
                    dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: 'User data updated!',
                            type: 'success',
                        },
                        { root: true }
                    )
                }
                commit('setLoading', false)
            } catch (e) {
                console.log(e)
                commit('setLoading', false)
            }
        },
        async addNewUserProbe({ state, dispatch }) {
            try {
                const resp = await UserDataService.addNewProbe(state.activeUser.id, state.newUserProbe)
                if (resp.status === 201) {
                    dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: resp.data.message,
                            type: 'success',
                        },
                        { root: true }
                    )
                    dispatch('fetchUser', state.activeUser.id)
                } else {
                    dispatch('app/showSnackbar', { bool: true, message: resp.message, type: 'error' }, { root: true })
                }
            } catch (e) {
                console.log(e)
            }
        },
        async editUserProbe({ state, dispatch }, probe) {
            try {
                const resp = await UserDataService.editUserProbe(state.activeUser.id, probe)
                if (resp.status === 200) {
                    dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: resp.data.message,
                            type: 'success',
                        },
                        { root: true }
                    )
                    dispatch('fetchUser', state.activeUser.id)
                    return { success: 1 }
                } else {
                    dispatch('app/showSnackbar', { bool: true, message: resp.message, type: 'error' }, { root: true })
                }
            } catch (e) {
                console.log(e)
            }
        },
        async deleteUserProbe({ state, dispatch }, probe) {
            try {
                const resp = await UserDataService.deleteUserProbe(state.activeUser.id, probe.probe_id)
                if (resp.status === 200) {
                    dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: resp.data.message,
                            type: 'success',
                        },
                        { root: true }
                    )
                    dispatch('fetchUser', state.activeUser.id)
                    return { success: 1 }
                } else {
                    dispatch('app/showSnackbar', { bool: true, message: resp.message, type: 'error' }, { root: true })
                }
            } catch (e) {
                console.log(e)
            }
        },
        async fetchAllPermissions({ commit }) {
            try {
                commit('setLoading', true)
                const resp = await UserDataService.getAllPermissions()
                if (resp.status === 200) {
                    commit('setPermissions', resp.data)
                    commit('userPermissions/setNewTag', resp.data, { root: true })
                }
                commit('setLoading', false)
            } catch (e) {
                console.log(e)
            }
        },
        async updateUserPermissions({ state, commit, dispatch }) {
            try {
                const resp = await UserDataService.updateUserPermissions(state.activeUser.id, state.userPermissions)

                if (resp.status === 200) {
                    await dispatch('fetchUser', state.activeUser.id)
                    dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: 'User data updated!',
                            type: 'success',
                        },
                        { root: true }
                    )
                }
                commit('setLoading', false)
            } catch (e) {
                console.log(e)
                commit('setLoading', false)
            }
        },
    },
    mutations: {
        setUsers(state, users) {
            state.users = users
        },
        setActiveUser(state, user) {
            state.activeUser = user
        },
        setLoading(state, bool) {
            state.loading = bool
        },
        setUsersList(state, users) {
            state.usersList = users
        },
        setSearchString(state, data) {
            state.searchString = data
        },
        setTableOptions(state, data) {
            state.tableOptions = data
            this.dispatch('user/fetchUserList')
        },
        setUsersCount(state, value) {
            state.usersCount = value
        },
        setPermissions(state, data) {
            state.permissions = { ...data }
        },
        setUserPermissions(state, data) {
            state.userPermissions = { ...data }
        },
    },
}
